var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');
var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var Radio = require('backbone.radio');
var services = Radio.channel('services');
var notificationsChannel = Radio.channel('notifications');
var utils = new CommonUtils();

var DocumentSignStatisticByComments2RowView = Marionette.View.extend({
    tagName: 'div',
    template: require('../../templates/statistics/document-sign-statistic-by-comments-2-row.html'),

    ui: {
        commentPopover: '.comment-popover',
        collapser: '.collapser'
    },

    events: {
        'click @ui.collapser': 'onToggleCollapse',
        'click @ui.commentPopover': 'onCommentPopoverClick'
    },

    templateContext: function () {
        var that = this;

        var commentsCount = that.model.get('comments').length;

        var signedDocuments = _.chain(that.model.get('comments') || [])
            .map(function (comment) {
                return comment.signedDocuments || [];
            })
            .flatten()
            .uniq()
            .value();

        var signedCount = signedDocuments.length;

        var notSignedDocuments = _.chain(that.model.get('comments') || [])
            .map(function (comment) {
                return _.union(comment.notAssignedDocuments || [],
                    comment.obsoletedDocuments || [],
                    comment.pendingDocuments || []);
            })
            .flatten()
            .uniq()
            .value();

        var notSignedCount = notSignedDocuments.length;

        return {
            commentsCount: commentsCount,
            signedLink: signedCount == 0
                ? '<a class="center" style="color: #ffffff">' + signedCount + '</a>'
                : '<a href="' + that.getDocumentsUrl(signedDocuments) + '" target="_blank" class="center white-link" style="color: #ffffff">' + signedCount + '</a>',
            notSignedLink: notSignedCount == 0
                ? '<a class="center white-link" style="color: #ffffff">' + notSignedCount + '</a>'
                : '<a href="' + that.getDocumentsUrl(notSignedDocuments) + '" target="_blank" class="center white-link" style="color: #ffffff">' + notSignedCount + '</a>',
            formatDateTime: function (long) {
                return long != undefined && long != '' && !isNaN(long)
                    ? that.utils.longToDateTimeFormatted(long, "MM/DD/YYYY hh:mm A") : '-'
            },
            getTotalCountForComment: function (comment) {
                return _.uniq(_.union(comment.signedDocuments || [],
                    comment.notAssignedDocuments || [],
                    comment.obsoletedDocuments || [],
                    comment.pendingDocuments || [])).length;
            },
            getTotalDocumentsUrlForComment: function (comment) {
                var totalDocuments = _.uniq(_.union(comment.signedDocuments || [],
                    comment.notAssignedDocuments || [],
                    comment.obsoletedDocuments || [],
                    comment.pendingDocuments || []));
                return that.getDocumentsUrl(totalDocuments);
            },
            orgSignedDocumentsLink: function (id) {
                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
                    + '&ORGANIZATION_REVIEW_FINISHED_REQUEST=' + id;
            },
            orgPendingDocumentsLink: function (id) {
                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
                    + '&ORGANIZATION_REVIEW_REQUEST=' + id;
            },
            personSignedDocumentsLink: function (id) {
                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
                    + '&PERSON_REVIEW_FINISHED_REQUEST=' + id;
            },
            personPendingDocumentsLink: function (id) {
                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
                    + '&PERSON_REVIEW_REQUEST=' + id;
            },
            patientSignedDocumentsLink: function (id) {
                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
                    + '&DOCUMENT_PATIENT=' + id + '&object_status=SIGNED&object_status=VIEWED';
            },
            patientPendingDocumentsLink: function (id) {
                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
                    + '&DOCUMENT_PATIENT=' + id + '&object_status=IN_REVIEW';
            },
            sortedBy: function (data, item) {
                return _.sortBy(data, item);
            },
            docsLink: function (ids) {
                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
                    + "&" + ids.map(function (id) {
                        return "id=" + id;
                    }).join("&");
            },
            calculateCleared: function (pendingCnt, signedCnt) {
                if (pendingCnt == 0 && signedCnt == 0)
                    return "-";
                else if (signedCnt == 0)
                    return "0";
                else if (pendingCnt == 0)
                    return "100";
                else
                    return new Number(signedCnt / (pendingCnt + signedCnt)).toFixed(2);
            }
        }
    },

    initialize: function (options) {
        this.utils = new CommonUtils();
        this.activeCommentPopoverId = null;
    },

    onRender: function () {
        var that = this;
        //that.ui.commentPopover.popover();
        that.ui.commentPopover.on('show.bs.popover', function () {
            var thisPopover = $(this);
            that.activeCommentPopoverId = thisPopover.attr("id");
            window.setTimeout(function () {
                that.activeCommentPopoverId = null;
            }, 1000);
        });
    },

    getDocumentsUrl: function (documentsIds) {
        return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
            + documentsIds.map(function (docId) {
                return "&id=" + docId;
            }).join('');
    },

    getPersonsUrl: function (ids) {
        return '/#persons?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
            + ids.map(function (docId) {
                return "&id=" + docId;
            }).join('');
    },

    getOrganizationsUrl: function (ids) {
        return '/#organizations?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
            + ids.map(function (docId) {
                return "&id=" + docId;
            }).join('');
    },


    onToggleCollapse: function (event) {
        var collapser = $(event.target);
        if (collapser.html() == "Show comments")
            $(event.target).html('Hide comments');
        else
            $(event.target).html('Show comments');
    },

    showPopover: function () {
        this.ui.commentPopover.popover("show");
    },

    hidePopover: function () {
        this.ui.commentPopover.popover("hide");
    },

    onCommentPopoverClick: function (event) {
        $(event.target).popover('show');
    },

    hideComments: function () {
        var that = this;
        that.ui.commentPopover.each(function () {
            var self = $(this);
            if (that.activeCommentPopoverId != self.attr("id")) {
                self.popover("hide");
            }
        });
    }
});

var DocumentSignStatisticByComments2TableBody = Marionette.CollectionView.extend({
    tagName: 'div',
    childView: DocumentSignStatisticByComments2RowView,

    collectionEvents: {},

    childViewEvents: {},

    initialize: function (options) {
        this.collection = options.collection;
    },

    childViewOptions: function () {
        return {};
    },

    findAndExpandComments: function (query) {
        var that = this;
        that.clearAndCollapseComments();

        that.collection.filter(function (model) {
            return model.get('commentText').indexOf(query) > -1;
        }).forEach(function (model) {
            var childView = that.children.findByModelCid(model.cid);
            childView.showPopover();
        });
    },

    clearAndCollapseComments: function () {
        $('[data-toggle="popover"]').popover("hide");
    },

    hideComments: function () {
        this.children.each(function (view) {
            view.hideComments();
        })
    }
});

var DocumentSignStatisticByComments2View = Marionette.View.extend({
    tagName: 'div',
    template: require('../../templates/statistics/document-sign-statistic-by-comments-2-view.html'),

    regions: {
        body: {
            el: '.list-of-commenters',
            replaceElement: true
        },
        commenter: "#commenter",
    },

    ui: {
        fromDateTime: '#from',
        toDateTime: '#to',
        filter: '#filter',

        commentQuery: '#comment-query',
        findComment: '#find-and-expand',
        clear: '#clear-and-collapse'
    },

    events: {
        'change @ui.fromDateTime': 'onFilterChange',
        'change @ui.toDateTime': 'onFilterChange',
        'click @ui.filter': 'filter',
        'click @ui.findComment': 'findAndExpandComments',
        'click @ui.clear': 'clearAndCollapseComments'
    },

    childViewEvents: {
        'suggestor:selected:commenter': 'onCommenterSelected'
    },

    templateContext: function () {
        var that = this;
        return {}
    },


    initialize: function (options) {
    },

    onRender: function () {
        var that = this;

        that.ui.fromDateTime.datetimepicker({
            showClear: true,
            showClose: true,
            useCurrent: false,
            format: 'MM/DD/YYYY hh:mm A'
        });
        that.ui.fromDateTime.on("dp.change", function (e) {
            that.enableOrDisableFilter();
        })
        that.ui.toDateTime.datetimepicker({
            showClear: true,
            showClose: true,
            useCurrent: false,
            format: 'MM/DD/YYYY hh:mm A'
        });
        that.ui.toDateTime.on("dp.change", function (e) {
            that.enableOrDisableFilter();
        })

        that.renderCommenterSelectView();

        that.collection = new Backbone.Collection();
        that.showChildView('body', new DocumentSignStatisticByComments2TableBody({
            collection: that.collection
        }));

        window.setTimeout(function () {
            $(function () {
                $("body").click(function (event) {
                    var clicked = $(event.target);
                    if (clicked.hasClass('popover-content') /*|| clicked.hasClass('comment-popover')*/)
                        return;

                    that.getChildView("body").hideComments();
                });
            });
        }, 1000);
    },

    onBeforeDestroy: function () {
        $("body").unbind("click");
    },

    renderCommenterSelectView: function () {

        var that = this;

        that.showChildView('commenter', new RemoteSuggesterView({
            maxNumberOfElements: 20,
            url: '/api/person/preview?page-size=' + 20
            + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data.filter(function (item) {
                    return item.object;
                });
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Select a commenter",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            tag: 'commenter'
        }));
    },

    filter: function () {
        var that = this;
        that.getData(function (response) {
            that.collection.reset(that.transformAndSort(response));
        });
    },

    getData: function (callback) {
        var that = this;

        utils.showSpinner();
        $.ajax({
            type: "GET",
            url: '/api/statistics/realtime/commenters/documents/filtered2' + '?' + that.getRequestParameters(),
            statusCode: {
                200: function (response) {
                    utils.hideSpinner();
                    if (_.isFunction(callback)) {
                        callback(response);
                    }
                }
            },
            error: function (e) {
                utils.hideSpinner();
                notificationsChannel.request('show:notification', e.responseJSON);
            }
        });
    },

    getRequestParameters: function () {
        var params = {};

        if (this.ui.fromDateTime.val() != undefined && this.ui.fromDateTime.val() != '')
            params['from_time'] = utils.dateToLong(this.ui.fromDateTime.val());
        else
            delete params['from_time'];
        if (this.ui.toDateTime.val() != undefined && this.ui.toDateTime.val() != '')
            params['to_time'] = utils.dateToLong(this.ui.toDateTime.val());
        else
            delete params['to_time'];
        if (this.commenter)
            params['commenter'] = this.commenter;
        else
            delete params['commenter'];

        return _.keys(params).map(function (key) {
            return key + "=" + params[key];
        }).join('&');
    },

    transformAndSort: function (items) {
        var grouped = _.groupBy(items, 'commenterId');
        var transformed = _.sortBy(_.keys(grouped).map(function (key) {
            return {
                commenterId: key,
                commenterIdInline: key.replace(/\./g, '') + "_2",
                commenterName: grouped[key][0].commenterName,
                comments: grouped[key]
            }
        }), 'commenterName');
        return transformed;
    },

    findAndExpandComments: function () {
        var query = this.ui.commentQuery.val();
        if (query.length < 3)
            return;
        this.getChildView("body").findAndExpandComments(query);
    },

    clearAndCollapseComments: function () {
        this.ui.commentQuery.val('');
        this.getChildView("body").clearAndCollapseComments();
    },

    onCommenterSelected: function (selected) {
        this.commenter = selected;
        this.enableOrDisableFilter();
    },

    enableOrDisableFilter: function () {
        console.log('enableOrDisableFilter');
        if (this.ui.fromDateTime.val() || this.ui.toDateTime.val() || this.commenter)
            this.ui.filter.removeAttr("disabled");
        else
            this.ui.filter.attr("disabled", true);
    }
});

module.exports = DocumentSignStatisticByComments2View;


//////////////////
// WEBPACK FOOTER
// ./app/views/statistics/document-sign-statistic-by-comments-view-2.js
// module id = 470
// module chunks = 0